import { render, staticRenderFns } from "./limitStatistic.vue?vue&type=template&id=2d08ab04"
import script from "./limitStatistic.vue?vue&type=script&lang=js"
export * from "./limitStatistic.vue?vue&type=script&lang=js"
import style0 from "./limitStatistic.vue?vue&type=style&index=0&id=2d08ab04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports